// extracted by mini-css-extract-plugin
module.exports = {"result":"CollectionsSection_result__31x0i"};